import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "VAvatar is-small" }
const _hoisted_3 = { class: "avatar is-fake is-info" }
const _hoisted_4 = { class: "dropdown-head has-background-grey-dark" }
const _hoisted_5 = { class: "VAvatar is-small" }
const _hoisted_6 = { class: "avatar is-fake is-info" }
const _hoisted_7 = { class: "meta" }
const _hoisted_8 = { class: "dropdown-item is-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VButton = _resolveComponent("VButton")!
  const _component_VDropdown = _resolveComponent("VDropdown")!

  return (_openBlock(), _createBlock(_component_VDropdown, {
    right: "",
    spaced: "",
    class: "user-dropdown profile-dropdown"
  }, {
    button: _withCtx(({ toggle }) => [
      _createElementVNode("a", {
        class: "is-trigger dropdown-trigger",
        "aria-haspopup": "true",
        onClick: toggle
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_ctx.user.initials), 1)
          ])
        ])
      ], 8, _hoisted_1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.user.initials), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", null, _toDisplayString(_ctx.user.first_name + ' ' + _ctx.user.last_name), 1)
        ])
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "dropdown-divider" }, null, -1)),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_VButton, {
          class: "logout-button",
          icon: "feather:log-out",
          color: "primary",
          role: "menuitem",
          raised: "",
          fullwidth: "",
          onClick: _ctx.logout
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Logout ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
}